import { render, staticRenderFns } from "./addindex.vue?vue&type=template&id=4ff3ab9e&scoped=true&"
import script from "./addindex.vue?vue&type=script&lang=js&"
export * from "./addindex.vue?vue&type=script&lang=js&"
import style0 from "./addindex.vue?vue&type=style&index=0&id=4ff3ab9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3ab9e",
  null
  
)

export default component.exports